import { renderRichText } from './richText'
import type { HubGuideStepsSection, HubSectionComponentProps } from './types'

export function HubGuideSteps({
  section,
}: HubSectionComponentProps<HubGuideStepsSection>) {
  if (section.steps.length === 0) return null

  return (
    <section id={section.id} className='flex flex-col gap-5'>
      {section.title && (
        <h2 className='font-display text-2xl font-bold leading-8 text-foreground'>
          {section.title}
        </h2>
      )}
      {section.dek && (
        <p className='text-base leading-6 text-foreground-secondary'>
          {section.dek}
        </p>
      )}

      <ol className='flex flex-col gap-3 text-foreground' role='list'>
        {section.steps.map((step, i) => {
          const stepNumber = step.index ?? i + 1
          return (
            <li
              key={`${stepNumber}-${step.label}`}
              className='flex items-start gap-3'
            >
              <span
                aria-hidden
                className='mt-0.5 inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-ds-bg-secondary text-sm font-semibold text-foreground-secondary'
              >
                {stepNumber}
              </span>
              <div className='flex min-w-0 flex-col gap-1 pt-0.5'>
                <p className='text-base font-medium leading-6 text-foreground'>
                  {step.label}
                  {step.optional && (
                    <span className='ml-2 text-xs font-normal text-foreground-tertiary'>
                      (optional)
                    </span>
                  )}
                </p>
                {step.description && (
                  <p className='text-sm leading-6 text-foreground-secondary'>
                    {renderRichText(step.description)}
                  </p>
                )}
              </div>
            </li>
          )
        })}

        {section.truncatedTailLabel && (
          <li className='pl-10 text-sm font-medium text-foreground-tertiary'>
            {section.truncatedTailLabel}
          </li>
        )}
      </ol>
    </section>
  )
}
